import React from 'react';

import Container from './Container';
import Image from './Image';
import Details from './Details';

export default ({ image, title, price }) => (
  <Container>
    <Image src={image} />
    <Details title={title} price={price} />
  </Container>
);
